// extracted by mini-css-extract-plugin
export var messageSideLeft = "_s4-1";
export var stateContainer = "_s4-0";